import { render, staticRenderFns } from "./Islemler.vue?vue&type=template&id=27136c6f&scoped=true"
import script from "./Islemler.vue?vue&type=script&lang=js"
export * from "./Islemler.vue?vue&type=script&lang=js"
import style0 from "./Islemler.vue?vue&type=style&index=0&id=27136c6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27136c6f",
  null
  
)

export default component.exports